import { usePlanLongStayParams as useLongStayParams } from "@/components/features/items/edit/plan/_shared/ui/components/stay-length/long-stay-params/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanLongStayParams = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { longStayParams } = viewModel;

	return useLongStayParams({ onSetViewModel, longStayParams });
};
